export default __webpack_public_path__ + "static/media/w-image.90af5853.png";